// eslint-disable-next-line jira/filename-case
import React from 'react';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import {
	initEntryPointConfig as initPlatformEntryPointConfig,
	type PlaceholderComponentProps,
} from '@atlassian/entry-point-config/ui';
import { ErrorFlagRenderer } from '@jira/platform__error-flag-renderer/src/ErrorBoundaryFlag.tsx';

const ModalOnError = ({ error }: { error: Error }) => {
	return <ErrorFlagRenderer id="" error={error} />;
};

export function initEntryPointConfig(): void {
	initPlatformEntryPointConfig({
		PlaceholderComponent: ({ name, ...props }: PlaceholderComponentProps) => (
			<Placeholder name={name || ''} {...props} />
		),
		UFOSegmentComponent: UFOSegment,
		ModalOnError,
	});
}
